export const SchedulerEndpoints = {
  Makes: "/getMakesByYear",
  Models: "/getModelsByYearAndMake",
  Years: "/getYears",
};
